import axios from 'app/axiosInstance'

export const getPatientsList = ({ page, pageSize, query = '' }) => {
    return axios().get(`v1/patients?Page.number=${page}&Page.Size=${pageSize}${query}`)
}

export const getPatientsCount = arg => {
    return axios().get(`v1/patients?Summary=count${arg}`)
}
